var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredSmilingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25C7 25 7 16 7 16H25C25 16 25 25 16 25Z",
    fill: "#BB1D80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5V16H24V16.5C24 17.0523 23.5523 17.5 23 17.5H9C8.44772 17.5 8 17.0523 8 16.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z",
    fill: "#F70A8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8172 9.75198C26.8022 12.0775 24.1215 13.0961 22.7473 13.4894C22.1841 13.6506 21.5932 13.4889 21.1762 13.0776C19.9831 11.9008 17.579 9.20094 17.0651 6.11839C16.3474 1.81356 21.7452 0.50123 23.9204 4.04935C29.0089 1.65928 31.7006 6.42423 28.8172 9.75198Z",
    fill: "#F70A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredSmilingFace);
export default __webpack_public_path__ + "static/media/coloredSmilingFace.7107d3614a7beb613812d0b333bf537e.svg";
export { ForwardRef as ReactComponent };